<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
import {getMonthFirstToLastDate} from '@qx/utils';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        orgIdOptions: [],
        orderStateOptions: [],
        customerTypeOptions: [],
        form: [
          { // 订单号
            label: '订单号',
            value: 'orderNo',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          { // 归属部门
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            default: [],
            placeholder: '请选择归属部门',
          },
          { // 客户单号
            label: '客户单号',
            value: 'customNumber',
            type: 'input',
            placeholder: '请输入客户单号',
          },
          { // 发车时间
            label: '发车时间',
            value: 'dependTime',
            type: 'date',
            default: [getMonthFirstToLastDate()[0], getMonthFirstToLastDate()[1]],
            placeholder: '请选择发车时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 线路名称
            label: '线路名称',
            value: 'sourceName',
            type: 'input',
            placeholder: '请输入线路名称',
          },
          { // 客户名称
            label: '客户名称',
            value: 'companyName',
            type: 'input',
            placeholder: '请输入客户名称',
          },
          { // 客户类型
            label: '客户类型',
            value: 'customerType',
            type: 'select',
            placeholder: '请输入客户类型',
          },
          { // 成本模式
            label: '成本模式',
            value: 'paymentWay',
            type: 'select',
            default: 0,
            placeholder: '请选择成本模式',
            options: [
              {
                label: '全部',
                value: 0,
              },
              {
                label: '承包模式',
                value: 3,
              },
              {
                label: '订单模式',
                value: 4,
              },
            ],
          },
          { // 车牌号
            label: '车牌号',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号',
          },
          { // 挂车车牌
            label: '挂车车牌',
            value: 'trailerNumber',
            type: 'input',
            placeholder: '请输入挂车车牌',
          },
          { // 主驾姓名
            label: '主驾姓名',
            value: 'carDriverMan',
            type: 'input',
            placeholder: '请输入主驾姓名',
          },
          { // 主驾手机
            label: '主驾手机',
            value: 'carDriverManMobile',
            type: 'input',
            placeholder: '请输入主驾手机',
          },
          { // 任务单号
            label: '任务单号',
            value: 'taskNo',
            type: 'input',
            placeholder: '请输入任务单号',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.dependTime && searchBoxData.dependTime.length) {
        searchBoxData.dependTimeBegin = this.formatDate(searchBoxData.dependTime[0]);
        searchBoxData.dependTimeEnd = this.formatDate(searchBoxData.dependTime[1]);
        delete searchBoxData.dependTime;
      }
      searchBoxData.orderType = 1;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    this.searchBoxData.orgIdOptions = await getDepartmentAllList();
    const customerTypeList = await getEnumList({
      codeType: 'CUSTOMER_TYPE_NAME',
    });
    this.searchBoxData.customerTypeOptions = Array.isArray(customerTypeList && customerTypeList[0]) ? customerTypeList[0] : [];
  },
};
</script>

<style lang="scss" scoped>
</style>
